var swiper = new Swiper(".block_shop-categorie-slider", {
  slidesPerView: 5,
  spaceBetween: 10,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  mousewheel: {
    forceToAxis: true,
  },
  navigation: {
    nextEl: ".block_shop-categories .block_slider-right-arrow",
    prevEl: ".block_shop-categories .block_slider-left-arrow",
  },
  breakpoints: {
    320: {
      slidesPerView: 2,
    },
    360: {
      slidesPerView: 3,
    },
    480: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4,
    },
    1499: {
      slidesPerView: 5,
    },
  },
});
